import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ConfirmModal from './ConfirmModal';
import { selectStyle as uiSelectStyle } from '../ui';
import { pole } from '../utils';

const API = process.env.REACT_APP_API_URL || '/api';

const inputStyle = { padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px', width: '100%', boxSizing: 'border-box' };
const selectStyle = { ...uiSelectStyle, padding: '8px 30px 8px 8px', minHeight: 0, fontSize: '14px', borderRadius: '6px', border: '1px solid #d1d5db' };
const btnGreen   = { padding: '8px 14px', background: '#3ab54a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' };
const btnGray    = { padding: '7px 14px', background: '#f1f5f9', color: '#374151', border: '1px solid #d1d5db', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' };

// ── Zákazníci & Provozovny ────────────────────────────────────────────────────

function KonfiguraceZakaznici() {
  const [zakaznici, setZakaznici] = useState([]);
  const [novyNazev, setNovyNazev] = useState('');
  const [novaZkratka, setNovaZkratka] = useState('');
  const [vybranyId, setVybranyId] = useState(null);
  const [novaProvozovna, setNovaProvozovna] = useState({ nazev: '', adresa: '', mesto: '' });
  const [chyba, setChyba] = useState('');
  const [modal, setModal] = useState(null);
  const [plnyNazev, setPlnyNazev] = useState({ id: null, hodnota: '', ulozeno: false });

  const nactiZakazniky = () => axios.get(`${API}/zakaznici`, { params: { pouze_aktivni: false } }).then(r => setZakaznici(pole(r.data))).catch(() => setZakaznici([]));
  useEffect(() => { nactiZakazniky(); }, []);

  const pridejZakaznika = async () => {
    if (!novyNazev.trim() || !novaZkratka.trim()) { setChyba('Vyplňte název i zkratku.'); return; }
    try {
      await axios.post(`${API}/zakaznici`, { nazev: novyNazev.trim(), zkratka: novaZkratka.trim().toUpperCase() });
      setNovyNazev(''); setNovaZkratka(''); setChyba('');
      nactiZakazniky();
    } catch (e) { setChyba(e.response?.data?.detail || 'Chyba při přidávání zákazníka.'); }
  };

  const smazZakaznika = (id, nazev) => {
    setModal({
      message: `Opravdu chcete deaktivovat zákazníka „${nazev}" i všechny jeho provozovny?`,
      onConfirm: async () => {
        setModal(null);
        await axios.delete(`${API}/zakaznici/${id}`);
        if (vybranyId === id) setVybranyId(null);
        nactiZakazniky();
      },
    });
  };

  const reaktivujZakaznika = async (id) => {
    await axios.put(`${API}/zakaznici/${id}/reaktivovat`);
    nactiZakazniky();
  };

  const pridejProvozovnu = async (zakaznikId) => {
    if (!novaProvozovna.nazev.trim()) return;
    await axios.post(`${API}/zakaznici/${zakaznikId}/provozovny`, {
      nazev: novaProvozovna.nazev.trim(),
      adresa: novaProvozovna.adresa.trim() || null,
      mesto: novaProvozovna.mesto.trim() || null,
    });
    setNovaProvozovna({ nazev: '', adresa: '', mesto: '' });
    nactiZakazniky();
  };

  const smazProvozovnu = (provozovnaId, nazev) => {
    setModal({
      message: `Opravdu chcete deaktivovat provozovnu „${nazev}"?`,
      onConfirm: async () => {
        setModal(null);
        await axios.delete(`${API}/provozovny/${provozovnaId}`);
        nactiZakazniky();
      },
    });
  };

  const reaktivujProvozovnu = async (provozovnaId) => {
    await axios.put(`${API}/provozovny/${provozovnaId}/reaktivovat`);
    nactiZakazniky();
  };

  const vybranýZakaznik = zakaznici.find(z => z.id === vybranyId);
  // rozpracovaná hodnota patří vždy jen jednomu zákazníkovi; po přepnutí se načte uložená
  const plnyNazevHodnota = plnyNazev.id === vybranyId ? plnyNazev.hodnota : (vybranýZakaznik?.full_legal_name || '');

  const ulozPlnyNazev = async () => {
    try {
      await axios.put(`${API}/zakaznici/${vybranyId}`, { full_legal_name: plnyNazevHodnota });
      setPlnyNazev({ id: vybranyId, hodnota: plnyNazevHodnota.trim(), ulozeno: true });
      setChyba('');
      nactiZakazniky();
    } catch (e) {
      setChyba(e.response?.data?.detail || 'Plný obchodní název se nepodařilo uložit');
    }
  };

  return (
    <div>
      {modal && <ConfirmModal message={modal.message} confirmLabel="Smazat" danger onConfirm={modal.onConfirm} onCancel={() => setModal(null)} />}

      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
        <strong style={{ fontSize: '14px', color: '#333' }}>Přidat zákazníka</strong>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px auto', gap: '8px', marginTop: '8px', alignItems: 'center' }}>
          <input style={inputStyle} placeholder="Název zákazníka" value={novyNazev} onChange={e => setNovyNazev(e.target.value)} />
          <input style={inputStyle} placeholder="Zkratka (BON)" value={novaZkratka} onChange={e => setNovaZkratka(e.target.value)} maxLength={6} />
          <button style={btnGreen} onClick={pridejZakaznika}>+ Přidat</button>
        </div>
        {chyba && <p style={{ color: 'red', fontSize: '13px', margin: '6px 0 0' }}>{chyba}</p>}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <div>
          <strong style={{ fontSize: '13px', color: '#6b7280' }}>ZÁKAZNÍCI</strong>
          {zakaznici.map(z => (
            <div key={z.id}
              onClick={() => z.aktivni && setVybranyId(z.id === vybranyId ? null : z.id)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', marginTop: '6px', borderRadius: '8px', cursor: z.aktivni ? 'pointer' : 'default', border: `1px solid ${z.id === vybranyId ? '#3ab54a' : '#e5e7eb'}`, background: z.id === vybranyId ? '#f0fdf4' : z.aktivni ? '#fff' : '#f9fafb', opacity: z.aktivni ? 1 : 0.6 }}>
              <div>
                <span style={{ fontWeight: 'bold', fontSize: '14px', color: z.aktivni ? 'inherit' : '#9ca3af' }}>{z.nazev}</span>
                <span style={{ marginLeft: '8px', fontSize: '12px', color: '#6b7280', background: '#f1f5f9', padding: '1px 6px', borderRadius: '4px' }}>{z.zkratka}</span>
                {!z.aktivni && <span style={{ marginLeft: '6px', fontSize: '11px', color: '#9ca3af' }}>neaktivní</span>}
                {z.aktivni && <span style={{ marginLeft: '6px', fontSize: '12px', color: '#9ca3af' }}>{z.provozovny?.filter(p => p.aktivni !== false).length || 0} provozoven</span>}
              </div>
              {z.aktivni
                ? <button onClick={e => { e.stopPropagation(); smazZakaznika(z.id, z.nazev); }}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '16px', padding: '0 4px' }}>×</button>
                : <button onClick={e => { e.stopPropagation(); reaktivujZakaznika(z.id); }}
                    style={{ padding: '3px 8px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', color: '#15803d' }}>Reaktivovat</button>
              }
            </div>
          ))}
          {zakaznici.length === 0 && <p style={{ color: '#9ca3af', fontSize: '13px', marginTop: '8px' }}>Žádní zákazníci.</p>}
        </div>

        <div>
          {vybranýZakaznik ? (
            <>
              <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '10px', marginBottom: '12px' }}>
                <label style={{ fontSize: '13px', color: '#6b7280', fontWeight: 'bold' }}>Plný obchodní název (pro PDF)</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '8px', marginTop: '6px' }}>
                  <input style={inputStyle} maxLength={200} placeholder={vybranýZakaznik.nazev} value={plnyNazevHodnota}
                    onChange={e => setPlnyNazev({ id: vybranyId, hodnota: e.target.value, ulozeno: false })}
                    onKeyDown={e => e.key === 'Enter' && ulozPlnyNazev()} />
                  <button style={btnGreen} onClick={ulozPlnyNazev}>Uložit</button>
                </div>
                <p style={{ fontSize: '12px', color: '#9ca3af', margin: '6px 0 0' }}>
                  {plnyNazev.id === vybranyId && plnyNazev.ulozeno ? 'Uloženo. ' : ''}
                  Použije se v předávacím protokolu. Když je prázdný, použije se krátký název „{vybranýZakaznik.nazev}“.
                </p>
              </div>
              <strong style={{ fontSize: '13px', color: '#6b7280' }}>PROVOZOVNY — {vybranýZakaznik.nazev.toUpperCase()}</strong>
              {vybranýZakaznik.provozovny?.map(p => (
                <div key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', marginTop: '6px', borderRadius: '6px', background: '#f9fafb', border: '1px solid #e5e7eb', opacity: p.aktivni !== false ? 1 : 0.6 }}>
                  <span style={{ fontSize: '13px', color: p.aktivni !== false ? 'inherit' : '#9ca3af' }}>
                    {p.nazev}
                    {(p.adresa || p.mesto) && <span style={{ display: 'block', fontSize: '12px', color: '#6b7280' }}>{[p.adresa, p.mesto].filter(Boolean).join(', ')}</span>}
                    {p.aktivni === false && <span style={{ marginLeft: '6px', fontSize: '11px' }}>neaktivní</span>}
                  </span>
                  {p.aktivni !== false
                    ? <button onClick={() => smazProvozovnu(p.id, p.nazev)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '15px' }}>×</button>
                    : <button onClick={() => reaktivujProvozovnu(p.id)} style={{ padding: '2px 8px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '5px', cursor: 'pointer', fontSize: '11px', color: '#15803d' }}>Reaktivovat</button>
                  }
                </div>
              ))}
              {(vybranýZakaznik.provozovny?.length || 0) === 0 && <p style={{ color: '#9ca3af', fontSize: '13px', marginTop: '8px' }}>Žádné provozovny.</p>}
              <div style={{ display: 'grid', gap: '6px', marginTop: '10px' }}>
                <input style={inputStyle} placeholder="Název provozovny" value={novaProvozovna.nazev}
                  onChange={e => setNovaProvozovna({ ...novaProvozovna, nazev: e.target.value })} />
                <input style={inputStyle} placeholder="Adresa (nepovinné)" value={novaProvozovna.adresa}
                  onChange={e => setNovaProvozovna({ ...novaProvozovna, adresa: e.target.value })} />
                <div style={{ display: 'flex', gap: '6px' }}>
                  <input style={{ ...inputStyle, flex: 1 }} placeholder="Město (nepovinné)" value={novaProvozovna.mesto}
                    onChange={e => setNovaProvozovna({ ...novaProvozovna, mesto: e.target.value })}
                    onKeyDown={e => e.key === 'Enter' && pridejProvozovnu(vybranýZakaznik.id)} />
                  <button style={btnGreen} onClick={() => pridejProvozovnu(vybranýZakaznik.id)}>+</button>
                </div>
              </div>
            </>
          ) : (
            <p style={{ color: '#9ca3af', fontSize: '13px', marginTop: '24px' }}>← Vyberte zákazníka pro správu provozoven.</p>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Technici ──────────────────────────────────────────────────────────────────

const ROLE_LABEL = { technik: 'Technik', dispecer: 'Dispečer', admin: 'Admin' };

function KonfiguraceTechnici() {
  const [technici, setTechnici] = useState([]);
  const [pracoviste, setPracoviste] = useState([]);
  const [novaRole, setNovaRole] = useState('technik');
  const [novyJmeno, setNovyJmeno] = useState('');
  const [chyba, setChyba] = useState('');
  const [info, setInfo] = useState('');
  const [editId, setEditId] = useState(null);
  const [editJmeno, setEditJmeno] = useState('');
  const [pinEditId, setPinEditId] = useState(null);
  const [pinValue, setPinValue] = useState('');
  const [pinChyba, setPinChyba] = useState('');
  const [emailEditId, setEmailEditId] = useState(null);
  const [emailValue, setEmailValue] = useState('');

  const nactiTechniky = () => axios.get(`${API}/technici`).then(r => setTechnici(pole(r.data))).catch(() => setTechnici([]));
  useEffect(() => { nactiTechniky(); axios.get(`${API}/pracoviste`).then(r => setPracoviste(pole(r.data))).catch(() => {}); }, []);

  const zmen = async (t, data) => {
    try {
      await axios.put(`${API}/technici/${t.id}`, data);
      setChyba('');
      setInfo(('muze_resit' in data || 'role' in data) ? 'Změna se projeví po novém přihlášení uživatele.' : '');
    } catch (e) { setChyba(e.response?.data?.detail || 'Chyba při ukládání.'); setInfo(''); }
    nactiTechniky();
  };

  const nastavitPin = async (id) => {
    if (!pinValue.trim()) { setPinChyba('Zadejte PIN.'); return; }
    if (!/^\d{4,12}$/.test(pinValue)) { setPinChyba('PIN musí mít 4 až 12 číslic.'); return; }
    try {
      await axios.put(`${API}/technici/${id}`, { pin: pinValue });
      setPinEditId(null); setPinValue(''); setPinChyba('');
      nactiTechniky();
    } catch (e) { setPinChyba(e.response?.data?.detail || 'Chyba při nastavení PIN.'); }
  };

  const pridej = async () => {
    if (!novyJmeno.trim()) { setChyba('Vyplňte jméno.'); return; }
    try {
      await axios.post(`${API}/technici`, { jmeno: novyJmeno.trim(), role: novaRole });
      setNovyJmeno(''); setChyba('');
      nactiTechniky();
    } catch (e) { setChyba(e.response?.data?.detail || 'Chyba při přidávání.'); }
  };

  const ulozitEmail = async (id) => {
    const email = emailValue.trim();
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { setChyba('Neplatná e-mailová adresa.'); return; }
    try {
      await axios.put(`${API}/technici/${id}`, { email });
      setEmailEditId(null); setChyba('');
    } catch (e) { setChyba(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || 'Chyba při ukládání e-mailu.'); }
    nactiTechniky();
  };

  const toggleAktivni = async (t) => {
    await axios.put(`${API}/technici/${t.id}`, { aktivni: !t.aktivni });
    nactiTechniky();
  };

  const ulozitJmeno = async (id) => {
    if (!editJmeno.trim()) return;
    await axios.put(`${API}/technici/${id}`, { jmeno: editJmeno.trim() });
    setEditId(null);
    nactiTechniky();
  };

  return (
    <div>
      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
        <strong style={{ fontSize: '14px', color: '#333' }}>Přidat uživatele</strong>
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          <input style={{ ...inputStyle, flex: 1 }} placeholder="Celé jméno" value={novyJmeno} onChange={e => setNovyJmeno(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && pridej()} />
          <select style={{ ...selectStyle, width: 'auto' }} value={novaRole} onChange={e => setNovaRole(e.target.value)}>
            {Object.entries(ROLE_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <button style={btnGreen} onClick={pridej}>+ Přidat</button>
        </div>
      </div>
      {chyba && <p style={{ color: 'red', fontSize: '13px', margin: '0 0 8px' }}>{chyba}</p>}
      {info && <p style={{ color: '#1d4ed8', fontSize: '13px', margin: '0 0 8px' }}>{info}</p>}

      {technici.map(t => (
        <div key={t.id} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '10px', padding: '10px 12px', marginBottom: '6px', borderRadius: '8px', border: '1px solid #e5e7eb', background: t.aktivni ? '#fff' : '#f9fafb', opacity: t.aktivni ? 1 : 0.7 }}>
          {editId === t.id ? (
            <>
              <input style={{ ...inputStyle, flex: 1, marginBottom: 0 }} value={editJmeno} onChange={e => setEditJmeno(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && ulozitJmeno(t.id)} autoFocus />
              <button style={btnGreen} onClick={() => ulozitJmeno(t.id)}>Uložit</button>
              <button onClick={() => setEditId(null)} style={btnGray}>Zrušit</button>
            </>
          ) : emailEditId === t.id ? (
            <>
              <input type="email" placeholder="E-mail (nepovinné)" value={emailValue} autoFocus
                onChange={e => setEmailValue(e.target.value)} onKeyDown={e => e.key === 'Enter' && ulozitEmail(t.id)}
                style={{ ...inputStyle, flex: 1, marginBottom: 0 }} />
              <button style={btnGreen} onClick={() => ulozitEmail(t.id)}>Uložit</button>
              <button onClick={() => setEmailEditId(null)} style={btnGray}>Zrušit</button>
            </>
          ) : pinEditId === t.id ? (
            <>
              <input type="password" inputMode="numeric" placeholder="Nový PIN" value={pinValue} autoFocus
                onChange={e => { setPinValue(e.target.value); setPinChyba(''); }}
                onKeyDown={e => e.key === 'Enter' && nastavitPin(t.id)}
                style={{ ...inputStyle, flex: 1, marginBottom: 0, letterSpacing: '4px' }} />
              <button style={btnGreen} onClick={() => nastavitPin(t.id)}>Uložit</button>
              <button onClick={() => { setPinEditId(null); setPinValue(''); setPinChyba(''); }} style={btnGray}>Zrušit</button>
              {pinChyba && <span style={{ color: '#ef4444', fontSize: '12px' }}>{pinChyba}</span>}
            </>
          ) : (
            <>
              <span style={{ flex: 1, fontWeight: 'bold', fontSize: '14px', minWidth: '120px' }}>{t.jmeno}</span>
              <select value={t.role} onChange={e => zmen(t, { role: e.target.value })} style={{ ...selectStyle, width: 'auto' }}>
                {Object.entries(ROLE_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
              <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '12px', color: '#374151' }}>
                <input type="checkbox" checked={!!t.muze_resit} onChange={e => zmen(t, { muze_resit: e.target.checked })} />
                Může být řešitelem (vyjíždí)
              </label>
              {t.muze_resit && (
                <select value={t.vychozi_pracoviste_id || ''} onChange={e => zmen(t, { vychozi_pracoviste_id: e.target.value ? Number(e.target.value) : null })}
                  style={{ ...selectStyle, width: 'auto' }} title="Výchozí pracoviště">
                  <option value="">— pracoviště —</option>
                  {pracoviste.map(p => <option key={p.id} value={p.id}>{p.nazev}</option>)}
                </select>
              )}
              <span style={{ fontSize: '12px', color: t.aktivni ? '#3ab54a' : '#9ca3af', background: t.aktivni ? '#f0fdf4' : '#f1f5f9', padding: '2px 8px', borderRadius: '10px' }}>
                {t.aktivni ? 'Aktivní' : 'Neaktivní'}
              </span>
              <span style={{ fontSize: '11px', color: t.ma_pin ? '#3ab54a' : '#9ca3af', background: t.ma_pin ? '#f0fdf4' : '#fef9c3', padding: '2px 8px', borderRadius: '10px', border: `1px solid ${t.ma_pin ? '#bbf7d0' : '#fde68a'}` }}>
                {t.ma_pin ? '🔒 má PIN' : '⚠️ bez PIN'}
              </span>
              <button onClick={() => { setEditId(t.id); setEditJmeno(t.jmeno); }} style={btnGray}>Přejmenovat</button>
              <button onClick={() => { setPinEditId(t.id); setPinValue(''); setPinChyba(''); }} style={btnGray}>Nastavit PIN</button>
              <button onClick={() => { setEmailEditId(t.id); setEmailValue(t.email || ''); setChyba(''); }} style={btnGray}
                title={t.email || 'E-mail není vyplněn'}>{t.email ? 'E-mail' : 'Přidat e-mail'}</button>
              <button onClick={() => toggleAktivni(t)}
                style={{ padding: '6px 10px', background: t.aktivni ? '#fff7ed' : '#f0fdf4', border: `1px solid ${t.aktivni ? '#fed7aa' : '#bbf7d0'}`, borderRadius: '5px', cursor: 'pointer', fontSize: '12px', color: t.aktivni ? '#c2410c' : '#15803d' }}>
                {t.aktivni ? 'Deaktivovat' : 'Aktivovat'}
              </button>
            </>
          )}
        </div>
      ))}
      {technici.length === 0 && <p style={{ color: '#9ca3af', fontSize: '13px' }}>Žádní uživatelé.</p>}
    </div>
  );
}

// ── Pracoviště ────────────────────────────────────────────────────────────

function KonfiguracePracoviste() {
  const [mista, setMista] = useState([]);
  const [novyNazev, setNovyNazev] = useState('');
  const [chyba, setChyba] = useState('');

  const nactiMista = () => axios.get(`${API}/pracoviste`, { params: { pouze_aktivni: false } }).then(r => setMista(pole(r.data))).catch(() => setMista([]));
  useEffect(() => { nactiMista(); }, []);

  const pridej = async () => {
    if (!novyNazev.trim()) { setChyba('Vyplňte název pracoviště.'); return; }
    try {
      await axios.post(`${API}/pracoviste`, { nazev: novyNazev.trim() });
      setNovyNazev(''); setChyba('');
      nactiMista();
    } catch (e) { setChyba(e.response?.data?.detail || 'Chyba při přidávání pracoviště.'); }
  };

  const toggleAktivni = async (m) => {
    await axios.put(`${API}/pracoviste/${m.id}`, { aktivni: !m.aktivni });
    nactiMista();
  };

  return (
    <div>
      <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '14px', marginBottom: '16px' }}>
        <strong style={{ fontSize: '14px', color: '#333' }}>Přidat pracoviště</strong>
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          <input style={{ ...inputStyle, flex: 1 }} placeholder="Název pracoviště" value={novyNazev} onChange={e => setNovyNazev(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && pridej()} />
          <button style={btnGreen} onClick={pridej}>+ Přidat</button>
        </div>
        {chyba && <p style={{ color: 'red', fontSize: '13px', margin: '6px 0 0' }}>{chyba}</p>}
      </div>

      {mista.map(m => (
        <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', marginBottom: '6px', borderRadius: '8px', border: '1px solid #e5e7eb', background: m.aktivni ? '#fff' : '#f9fafb', opacity: m.aktivni ? 1 : 0.7 }}>
          <span style={{ flex: 1, fontWeight: 'bold', fontSize: '14px' }}>{m.nazev}</span>
          <span style={{ fontSize: '12px', color: m.aktivni ? '#3ab54a' : '#9ca3af', background: m.aktivni ? '#f0fdf4' : '#f1f5f9', padding: '2px 8px', borderRadius: '10px' }}>
            {m.aktivni ? 'Aktivní' : 'Neaktivní'}
          </span>
          <button onClick={() => toggleAktivni(m)}
            style={{ padding: '6px 10px', background: m.aktivni ? '#fff7ed' : '#f0fdf4', border: `1px solid ${m.aktivni ? '#fed7aa' : '#bbf7d0'}`, borderRadius: '5px', cursor: 'pointer', fontSize: '12px', color: m.aktivni ? '#c2410c' : '#15803d' }}>
            {m.aktivni ? 'Deaktivovat' : 'Aktivovat'}
          </button>
        </div>
      ))}
      {mista.length === 0 && <p style={{ color: '#9ca3af', fontSize: '13px' }}>Žádná pracoviště.</p>}
    </div>
  );
}

// ── SLA a priority ────────────────────────────────────────────────────────────

const cisloText = v => (v === null || v === undefined ? '' : String(v).replace('.', ','));
const lhutaText = v => (v === null || v === undefined ? 'nesleduje se' : `${cisloText(v)} h`);
const naCislo = v => (String(v).trim() === '' ? null : Number(String(v).replace(',', '.')));

// Tabulka je jen pro čtení; „Upravit“ přepne řádky jednoho zákazníka do editace, ukládá se až tlačítkem „Uložit“.
// onDirty hlásí rodiči, že jsou rozpracované neuložené změny (kvůli upozornění při odchodu).
function KonfiguraceSla({ onDirty }) {
  const [zakaznici, setZakaznici] = useState([]);
  const [priority, setPriority] = useState([]);
  const [pravidla, setPravidla] = useState([]);
  const [edit, setEdit] = useState(null);   // { zakaznikId, hodnoty: { [prioritaId]: { reakce, vyreseni } } }
  const [chyba, setChyba] = useState('');
  const [ulozeno, setUlozeno] = useState('');
  const [uklada, setUklada] = useState(false);

  const nacti = async () => {
    try {
      const [z, p, r] = await Promise.all([
        axios.get(`${API}/zakaznici`), axios.get(`${API}/priority`), axios.get(`${API}/sla-pravidla`),
      ]);
      setZakaznici(pole(z.data)); setPriority(pole(p.data)); setPravidla(pole(r.data));
    } catch { setChyba('Nepodařilo se načíst SLA pravidla.'); }
  };
  useEffect(() => { nacti(); }, []);

  const pravidlo = (zId, pId) => pravidla.find(x => x.zakaznik_id === zId && x.priorita_id === pId);
  const puvodni = (zId, pId) => {
    const r = pravidlo(zId, pId);
    return { reakce: cisloText(r?.reakce_h), vyreseni: cisloText(r?.vyreseni_h) };
  };

  const zmeneno = (zId, pId) => {
    if (!edit || edit.zakaznikId !== zId) return false;
    const h = edit.hodnoty[pId], o = puvodni(zId, pId);
    return naCislo(h.reakce) !== naCislo(o.reakce) || naCislo(h.vyreseni) !== naCislo(o.vyreseni);
  };
  const dirty = !!edit && priority.some(p => zmeneno(edit.zakaznikId, p.id));

  useEffect(() => { if (onDirty) onDirty(dirty); }, [dirty]);          // eslint-disable-line
  useEffect(() => () => { if (onDirty) onDirty(false); }, []);         // eslint-disable-line
  useEffect(() => {
    if (!dirty) return undefined;
    const h = e => { e.preventDefault(); e.returnValue = ''; };      // zavření záložky / obnovení stránky
    window.addEventListener('beforeunload', h);
    return () => window.removeEventListener('beforeunload', h);
  }, [dirty]);

  const upravit = z => {
    setChyba(''); setUlozeno('');
    setEdit({ zakaznikId: z.id, hodnoty: Object.fromEntries(priority.map(p => [p.id, puvodni(z.id, p.id)])) });
  };
  const nastav = (pId, pole_, v) => setEdit(e => ({ ...e, hodnoty: { ...e.hodnoty, [pId]: { ...e.hodnoty[pId], [pole_]: v } } }));
  const zrusit = () => { setEdit(null); setChyba(''); };

  const uloz = async z => {
    const zmenene = priority.filter(p => zmeneno(z.id, p.id));
    for (const p of zmenene) {
      const r = naCislo(edit.hodnoty[p.id].reakce), v = naCislo(edit.hodnoty[p.id].vyreseni);
      if ([r, v].some(x => x !== null && (Number.isNaN(x) || x < 0))) {
        setChyba(`${p.nazev}: lhůta musí být nezáporné číslo, nebo prázdná (= nesleduje se).`); return;
      }
    }
    setUklada(true); setChyba('');
    try {
      for (const p of zmenene) {
        await axios.put(`${API}/sla-pravidla`, {
          zakaznik_id: z.id, priorita_id: p.id,
          reakce_h: naCislo(edit.hodnoty[p.id].reakce), vyreseni_h: naCislo(edit.hodnoty[p.id].vyreseni),
        });
      }
      await nacti();
      setEdit(null);
      setUlozeno(zmenene.length ? `Uloženo: ${z.nazev}. Změna se týká jen nově založených tiketů.` : `${z.nazev}: žádná změna.`);
    } catch (e) {
      setChyba(e.response?.data?.detail || 'Chyba při ukládání, změny zůstaly rozpracované.');
      await nacti();
    }
    setUklada(false);
  };

  const inp = { ...inputStyle, width: '110px' };
  return (
    <div>
      <p style={{ fontSize: '13px', color: '#6b7280', marginTop: 0 }}>
        Lhůty v hodinách. Prázdné pole = lhůta se nesleduje. Změna se týká jen nově založených tiketů.
      </p>
      {chyba && <p style={{ color: 'red', fontSize: '13px' }}>{chyba}</p>}
      {ulozeno && !chyba && <p style={{ color: '#15803d', fontSize: '13px' }}>✓ {ulozeno}</p>}
      {zakaznici.map(z => {
        const edituje = edit?.zakaznikId === z.id;
        return (
          <div key={z.id} style={{ border: `1px solid ${edituje ? '#3ab54a' : '#e5e7eb'}`, borderRadius: '8px', padding: '12px', marginBottom: '12px', background: edituje ? '#f0fdf4' : '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <strong style={{ fontSize: '15px' }}>{z.nazev}</strong>
              {edituje ? (
                <span style={{ display: 'flex', gap: '8px' }}>
                  <button style={btnGreen} onClick={() => uloz(z)} disabled={uklada}>{uklada ? 'Ukládám…' : 'Uložit'}</button>
                  <button style={btnGray} onClick={zrusit} disabled={uklada}>Zrušit</button>
                </span>
              ) : (
                <button style={{ ...btnGray, opacity: edit ? 0.5 : 1 }} onClick={() => upravit(z)} disabled={!!edit}
                  title={edit ? 'Nejdřív uložte nebo zrušte rozpracovanou úpravu' : ''}>Upravit</button>
              )}
            </div>
            {priority.map(p => (
              <div key={p.id} style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginTop: '8px' }}>
                <span style={{ width: '90px', fontSize: '13px' }}>{p.nazev}</span>
                {edituje ? (
                  <>
                    <input style={inp} inputMode="decimal" placeholder="reakce (h)" aria-label={`${z.nazev} ${p.nazev} reakce`}
                      value={edit.hodnoty[p.id].reakce} onChange={e => nastav(p.id, 'reakce', e.target.value)} />
                    <input style={inp} inputMode="decimal" placeholder="vyřešení (h)" aria-label={`${z.nazev} ${p.nazev} vyřešení`}
                      value={edit.hodnoty[p.id].vyreseni} onChange={e => nastav(p.id, 'vyreseni', e.target.value)} />
                    {zmeneno(z.id, p.id) && <span style={{ fontSize: '12px', color: '#b45309' }}>neuloženo</span>}
                  </>
                ) : (
                  <span style={{ fontSize: '14px' }}>
                    reakce <strong>{lhutaText(pravidlo(z.id, p.id)?.reakce_h)}</strong> · vyřešení <strong>{lhutaText(pravidlo(z.id, p.id)?.vyreseni_h)}</strong>
                  </span>
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

// ── Ceník telefonické konzultace ──────────────────────────────────────────────

const kcText = v => String(Number(v)).replace('.', ',');

function CenikRadek({ cenik, nazev, onUlozit, onSmazat }) {
  const vychozi = { zdarma: String(cenik.zdarma_do_min), pausal: String(cenik.pausal_do_min), kc: kcText(cenik.pausal_kc) };
  const [h, setH] = useState(vychozi);
  const zmeneno = h.zdarma !== vychozi.zdarma || h.pausal !== vychozi.pausal || h.kc !== vychozi.kc;
  const pole_ = { ...inputStyle, width: '90px' };
  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px', marginBottom: '10px', background: '#fff' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <strong style={{ fontSize: '15px' }}>{nazev}</strong>
        {onSmazat && <button style={btnGray} onClick={onSmazat}>Smazat výjimku</button>}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'flex-end', marginTop: '8px', fontSize: '13px' }}>
        <label>Zdarma do (min)<input style={pole_} inputMode="numeric" value={h.zdarma} onChange={e => setH({ ...h, zdarma: e.target.value })} /></label>
        <label>Paušál do (min)<input style={pole_} inputMode="numeric" value={h.pausal} onChange={e => setH({ ...h, pausal: e.target.value })} /></label>
        <label>Paušál (Kč bez DPH)<input style={pole_} inputMode="decimal" value={h.kc} onChange={e => setH({ ...h, kc: e.target.value })} /></label>
        <button style={{ ...btnGreen, opacity: zmeneno ? 1 : 0.5 }} disabled={!zmeneno}
          onClick={() => onUlozit(cenik.zakaznik_id, h)}>Uložit</button>
        {zmeneno && <span style={{ color: '#b45309' }}>neuloženo</span>}
      </div>
    </div>
  );
}

function KonfiguraceCenik() {
  const [ceniky, setCeniky] = useState([]);
  const [zakaznici, setZakaznici] = useState([]);
  const [novyZakaznik, setNovyZakaznik] = useState('');
  const [chyba, setChyba] = useState('');
  const [ulozeno, setUlozeno] = useState('');
  const [modal, setModal] = useState(null);

  const nacti = async () => {
    try {
      const [c, z] = await Promise.all([axios.get(`${API}/konzultace-ceniky`), axios.get(`${API}/zakaznici`)]);
      setCeniky(pole(c.data)); setZakaznici(pole(z.data));
    } catch { setChyba('Nepodařilo se načíst ceník.'); }
  };
  useEffect(() => { nacti(); }, []);

  const ulozit = async (zakaznikId, h) => {
    const zdarma = Number(h.zdarma), pausal = Number(h.pausal), kc = Number(String(h.kc).replace(',', '.'));
    if (![zdarma, pausal, kc].every(Number.isFinite) || !Number.isInteger(zdarma) || !Number.isInteger(pausal) || zdarma < 0 || kc < 0 || String(h.kc).trim() === '') {
      setChyba('Hranice musí být celá nezáporná čísla a cena nezáporné číslo.'); return;
    }
    if (zdarma >= pausal) { setChyba('Hranice paušálu musí být vyšší než hranice konzultace zdarma.'); return; }
    setChyba(''); setUlozeno('');
    try {
      await axios.put(`${API}/konzultace-ceniky`, { zakaznik_id: zakaznikId, zdarma_do_min: zdarma, pausal_do_min: pausal, pausal_kc: kc.toFixed(2) });
      await nacti();
      setNovyZakaznik('');
      setUlozeno('Uloženo. Změna se týká jen nově zapsaných konzultací.');
    } catch (e) {
      const d = e.response?.data?.detail;
      setChyba(typeof d === 'string' ? d : 'Chyba při ukládání ceníku.');
    }
  };
  const smazat = async c => {
    try { await axios.delete(`${API}/konzultace-ceniky/${c.id}`); await nacti(); setUlozeno('Výjimka smazána, platí výchozí ceník.'); }
    catch (e) { setChyba(e.response?.data?.detail || 'Výjimku se nepodařilo smazat.'); }
  };

  const nazevZakaznika = id => zakaznici.find(z => z.id === id)?.nazev || `#${id}`;
  const vychozi = ceniky.find(c => c.zakaznik_id === null);
  const vyjimky = ceniky.filter(c => c.zakaznik_id !== null);
  const volni = zakaznici.filter(z => !vyjimky.some(c => c.zakaznik_id === z.id));
  return (
    <div>
      <p style={{ fontSize: '13px', color: '#6b7280', marginTop: 0 }}>
        Telefonická konzultace: vyřešená do první hranice včetně je zdarma, vyřešená do druhé hranice včetně se účtuje paušálem bez DPH.
        Nevyřešená konzultace a konzultace nad druhou hranici mají cenu neurčenu. Změna se týká jen nově zapsaných konzultací.
      </p>
      {chyba && <p style={{ color: 'red', fontSize: '13px' }}>{chyba}</p>}
      {ulozeno && !chyba && <p style={{ color: '#15803d', fontSize: '13px' }}>✓ {ulozeno}</p>}
      {vychozi && <CenikRadek key={`v${vychozi.zdarma_do_min}-${vychozi.pausal_do_min}-${vychozi.pausal_kc}`} cenik={vychozi} nazev="Výchozí ceník (všichni zákazníci)" onUlozit={ulozit} />}
      <h4 style={{ margin: '16px 0 8px' }}>Výjimky pro zákazníky</h4>
      {vyjimky.length === 0 && <p style={{ fontSize: '13px', color: '#6b7280' }}>Žádná výjimka, všichni zákazníci mají výchozí ceník.</p>}
      {vyjimky.map(c => (
        <CenikRadek key={`${c.id}-${c.zdarma_do_min}-${c.pausal_do_min}-${c.pausal_kc}`} cenik={c} nazev={nazevZakaznika(c.zakaznik_id)}
          onUlozit={ulozit} onSmazat={() => setModal(c)} />
      ))}
      {vychozi && volni.length > 0 && (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <select style={{ ...selectStyle, width: '220px' }} value={novyZakaznik} onChange={e => setNovyZakaznik(e.target.value)}>
            <option value="">— zákazník —</option>
            {volni.map(z => <option key={z.id} value={z.id}>{z.nazev}</option>)}
          </select>
          <button style={btnGreen} disabled={!novyZakaznik}
            onClick={() => ulozit(Number(novyZakaznik), { zdarma: String(vychozi.zdarma_do_min), pausal: String(vychozi.pausal_do_min), kc: kcText(vychozi.pausal_kc) })}>
            Přidat výjimku
          </button>
        </div>
      )}
      {modal && (
        <ConfirmModal confirmLabel="Smazat" danger message={`Zákazník ${nazevZakaznika(modal.zakaznik_id)} bude mít znovu výchozí ceník. Už zapsané konzultace se nemění.`}
          onConfirm={() => { const c = modal; setModal(null); smazat(c); }} onCancel={() => setModal(null)} />
      )}
    </div>
  );
}

// ── Konfigurace ───────────────────────────────────────────────────────────────

function Konfigurace({ guard, setDirty }) {
  const [konfTab, setKonfTab] = useState('zakaznici');
  const subBtn = (id, label) => (
    <button onClick={() => guard(() => setKonfTab(id))} style={{ padding: '6px 16px', border: 'none', cursor: 'pointer', fontSize: '13px', background: konfTab === id ? '#333' : '#f1f5f9', color: konfTab === id ? 'white' : '#374151', borderRadius: '5px', marginRight: '6px' }}>{label}</button>
  );
  return (
    <div>
      <h3 style={{ marginBottom: '12px', color: '#333' }}>Konfigurace</h3>
      <div style={{ marginBottom: '16px' }}>
        {subBtn('zakaznici', 'Zákazníci & Provozovny')}
        {subBtn('technici', 'Uživatelé')}
        {subBtn('pracoviste', 'Pracoviště')}
        {subBtn('sla', 'SLA')}
        {subBtn('cenik', 'Ceník konzultací')}
      </div>
      {konfTab === 'zakaznici'       && <KonfiguraceZakaznici />}
      {konfTab === 'technici'        && <KonfiguraceTechnici />}
      {konfTab === 'pracoviste'      && <KonfiguracePracoviste />}
      {konfTab === 'sla'             && <KonfiguraceSla onDirty={setDirty} />}
      {konfTab === 'cenik'           && <KonfiguraceCenik />}
    </div>
  );
}

// ── Hlavní AdminView ──────────────────────────────────────────────────────────

function AdminView({ setStranka, naviguj, initialTab }) {
  const [tab, setTab] = useState(initialTab || 'konfigurace');
  const [dirty, setDirty] = useState(false);          // rozpracovaná neuložená úprava (SLA)
  const [cekajiciAkce, setCekajiciAkce] = useState(null);
  // Odchod z rozpracované úpravy: nejdřív upozornit na neuložené změny
  const guard = akce => { if (dirty) setCekajiciAkce(() => akce); else akce(); };

  const tabBtn = (id, label) => (
    <button onClick={() => setTab(id)} style={{
      padding: '8px 20px', border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: tab === id ? 'bold' : 'normal',
      background: tab === id ? '#3ab54a' : '#f1f5f9', color: tab === id ? 'white' : '#374151',
      borderRadius: '6px', marginRight: '6px',
    }}>{label}</button>
  );

  return (
    <div>
      {cekajiciAkce && (
        <ConfirmModal message="Máte neuložené změny SLA pravidel. Opravdu odejít bez uložení?" confirmLabel="Odejít bez uložení" danger
          onConfirm={() => { const a = cekajiciAkce; setCekajiciAkce(null); setDirty(false); a(); }} onCancel={() => setCekajiciAkce(null)} />
      )}
      <button onClick={() => guard(() => setStranka('rozcesti'))}
        style={{ marginBottom: '16px', background: 'transparent', border: '1px solid #9ca3af', color: '#555', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>
        ← Zpět
      </button>
      <h2 style={{ marginBottom: '12px', color: '#333' }}>Admin</h2>

      <div style={{ marginBottom: '20px' }}>
        {tabBtn('konfigurace', 'Konfigurace')}
      </div>

      <div style={{ background: '#ffffff', borderRadius: '10px', padding: '20px' }}>
                {tab === 'konfigurace' && <Konfigurace guard={guard} setDirty={setDirty} />}
      </div>
    </div>
  );
}

export default AdminView;
